import { Link } from "react-router-dom";
import styles from "./styles.module.css";

export default PageDrumTrainerDeleteAccount

function PageDrumTrainerDeleteAccount() {
   return <section>
      <div className={styles.header}>
         Drum Trainer
      </div>
      <div className={styles.caption}>
         Delete Your Account
         <br></br>
         <br></br>
         This page explains how to delete your Drum Trainer account and what happens to your data. The app is made by Erik Andresen and accounts are created with Google or Apple sign in.
         <br></br>
         <br></br>
         <b>How to delete your account</b>
         <br />
         1. Open the app and go to <b>Community</b>.
         <br />
         2. Tap <b>Profile</b>.
         <br />
         3. Tap the <b>Delete account</b> button on the right.
         <br />
         4. Sign in again if prompted.
         <br />
         5. Your account and data will then be deleted.
         <br></br>
         <br></br>
         <b>What is deleted</b>
         <br />
         Your sign in account and your profile, including your nickname and your user id, are permanently removed. This happens right away and cannot be undone.
         <br></br>
         <br></br>
         <b>What is kept</b>
         <br />
         Beats you have uploaded to the Community stay available to other users, together with the nickname they were published under. If you want them gone as well, remove them before you delete your account. Go to <b>Community</b>, tap <b>Profile</b>, and remove each beat in your list of uploaded beats.
         <br></br>
         <br></br>
         Beats and settings that are stored only on your phone are not sent anywhere, and they disappear when you uninstall the app.
         <br></br>
         <br></br>
         <b>If you cannot open the app</b>
         <br />
         Send an email to erikandresen10@gmail.com from the address your account was created with, and the account will be deleted for you.
         <br></br>
         <br></br>
         See also the <Link to="/shabibi/drumtrainer/privacy">Drum Trainer Privacy Policy</Link>.
      </div>
   </section>;
}
